export default {
  QUEUED: 'queued',
  STARTED: 'started',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
};
